<template>
    <div class="bg-white rounded">
        <div class="table pt-3 mb-0">
            <div class="add_license d-flex justify-content-between align-items-center flex-wrap mb-3 px-3">
                <h3 class="font-weight-bold f-20 text-left mb-0 text-black">{{ $t('docTypes.title') }}</h3>
                <b-button @click="$bvModal.show('add-type-modal')" v-if="allowAddDocType"
                    class="export equipment d-flex justify-content-center align-items-center w-fit-content"
                    variant="primary">
                    <b-icon icon="plus" class="p-0" aria-hidden="true"></b-icon>
                    <p class="mb-0 ml-2 text-white p-0">{{ $t('docTypes.addType') }}</p>
                </b-button>
            </div>
            <b-table :sticky-header="'calc(100vh - 273px)'" responsive :fields="translatedFields" :items="items" hover
                :per-page="perPage" :current-page="currentPage" show-empty>
                <template #cell(required)="data">
                    <span>{{ data.value ? $t('docTypes.yes') : $t('docTypes.no') }}</span>
                </template>
                <template #cell(auto_archive)="data">
                    <span>{{ data.value ? $t('docTypes.yes') : $t('docTypes.no') }}</span>
                </template>
                <template #cell(auto_archive_on_update)="data">
                    <span>{{ data.value ? $t('docTypes.yes') : $t('docTypes.no') }}</span>
                </template>
                <template #cell(notify_driver)="data">
                    <span>{{ data.value ? $t('docTypes.yes') : $t('docTypes.no') }}</span>
                </template>
                <template #cell(notify_admin)="data">
                    <span>{{ data.value ? $t('docTypes.yes') : $t('docTypes.no') }}</span>
                </template>
                <template #cell(tags)="data">
                    <div v-if="data.value.length" class="d-flex align-items-center">
                        <div class="table-tags mr-2">{{ data.value[0].add_tag }}</div>
                        <v-app>
                            <v-tooltip bottom v-if="data.value.length > 1">
                                <template #activator="{ on, attrs }">
                                    <div class="table-tags" v-on="on" v-bind="attrs">+{{ data.value.length - 1 }}</div>
                                </template> <span
                                    v-html="data.value.map((tag) => tag.add_tag).slice(1).join('<br>')"></span>
                            </v-tooltip>
                        </v-app>
                    </div>
                    <p class="mb-0" v-else>-</p>
                </template>
                <template #cell(action)="data">
                    <div v-if="data.item.model !== 'All' && (allowUpdateDocType || allowDeleteDocType)">
                        <svg v-if="allowUpdateDocType" @click="editDocTypeItem(data.item)" class="cursor-pointer mr-4"
                            width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M5.52719 16.7477L14.5274 7.74753L10.2525 3.4726L1.25226 12.4728C1.12836 12.5969 1.04034 12.7522 0.997548 12.9222L0 18L5.07684 17.0025C5.2473 16.9598 5.40322 16.8717 5.52719 16.7477V16.7477ZM17.4329 4.84205C17.796 4.47881 18 3.98622 18 3.4726C18 2.95898 17.796 2.46639 17.4329 2.10315L15.8968 0.567123C15.5336 0.203994 15.041 0 14.5274 0C14.0138 0 13.5212 0.203994 13.1579 0.567123L11.6219 2.10315L15.8968 6.37808L17.4329 4.84205Z"
                                fill="#2CCE89" />
                        </svg>
                        <svg @click="showDocTypeDeletePopup(data.item.id)" v-if="allowDeleteDocType" width="19" height="20"
                            viewBox="0 0 19 20" fill="none" xmlns="http://www.w3.org/2000/svg" class="cursor-pointer">
                            <path d="M1 5.15704H17.6139" stroke="#FF0000" stroke-width="1.5" stroke-linecap="round"
                                stroke-linejoin="round"></path>
                            <path
                                d="M3.0766 5.15704H15.537V17.6175C15.537 17.9846 15.3911 18.3368 15.1315 18.5964C14.8719 18.856 14.5197 19.0019 14.1525 19.0019H4.46109C4.0939 19.0019 3.74175 18.856 3.4821 18.5964C3.22247 18.3368 3.0766 17.9846 3.0766 17.6175V5.15704Z"
                                stroke="#FF0000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                            <path
                                d="M5.84607 5.15347V4.46123C5.84607 3.54325 6.21073 2.66287 6.85984 2.01377C7.50894 1.36466 8.38932 1 9.3073 1C10.2253 1 11.1057 1.36466 11.7548 2.01377C12.4039 2.66287 12.7685 3.54325 12.7685 4.46123V5.15347"
                                stroke="#FF0000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                            <path d="M7.23175 9.3065V14.8466" stroke="#FF0000" stroke-width="1.5" stroke-linecap="round"
                                stroke-linejoin="round"></path>
                            <path d="M11.385 9.3065V14.8466" stroke="#FF0000" stroke-width="1.5" stroke-linecap="round"
                                stroke-linejoin="round"></path>
                        </svg>
                    </div>
                    <div v-else>-</div>
                </template>
            </b-table>
            <div class="entries-pagination px-0 px-sm-2">
                <div class="d-flex align-items-center flex-wrap">
                    <div class="text-left show-entries mr-md-3 pl-3 pl-md-0 ml-md-0">
                        <b-form-select v-model="perPage" :options="pageOptions" />
                    </div>
                    <div class="pagination">
                        <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage"
                            aria-controls="my-table"></b-pagination>
                    </div>
                    <p class="my-0 pr-3 pr-md-0 mr-md-1 mt-0 f-14">
                        {{ positionText }}
                    </p>
                </div>
            </div>
        </div>
        <b-modal id="add-type-modal" centered no-close-on-backdrop 
        :body-class="'px-3 pt-2 overflow-preview-auto'" :footer-class="'d-block border-0 pt-0 pb-3 m-0'"
            :header-class="'align-items-center'" scrollable
        no-close-on-esc>
            <template #modal-header="{ close }">
                <h5 class="modal-title">
                    {{ editDocType ? $t('docTypes.editType') : $t('docTypes.addType') }}
                </h5>
                <b-button size="sm" class="d-none" variant="outline-danger" @click="close()">
                    Close Modal
                </b-button>
            </template>
            <div class="body">
                <b-row>
                    <b-col cols="12" class="mt-3">
                        <b-form-group :label="$t('docTypes.typeLabel')" class="text-left mb-0">
                            <b-form-input v-model="form.type" :placeholder="$t('docTypes.typePlaceholder')" class="unit"
                                :disabled="!allowAddDocType && (!editDocType || (editDocType && !allowUpdateDocType))"
                                required></b-form-input>
                            <p v-if="errors && errors.type" class="field-error mb-lg-3">
                                {{ errors.type[0] }}
                            </p>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" class="mt-3">
                        <b-form-group :label="$t('docTypes.modelLabel')" class="text-left mb-0">
                            <b-form-select v-model="form.model" @change="getModelValue($event)"
                                :disabled="!allowAddDocType && (!editDocType || (editDocType && !allowUpdateDocType))"
                                :options="modelSelectOptions" class="unit f-12" required />
                            <p v-if="errors && errors.model" class="field-error mb-lg-3">
                                {{ errors.model[0] }}
                            </p>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" class="mt-3" v-if="form.model !== 'Company'">
                        <b-form-group :label="$t('docTypes.requiredLabel')" class="text-left mb-0">
                            <b-form-select @change="form.tags = []"
                                :disabled="!allowAddDocType && (!editDocType || (editDocType && !allowUpdateDocType))"
                                v-model="form.required" :options="yesNoOptions" class="unit f-12" required />
                            <p v-if="errors && errors.required" class="field-error mb-lg-3">
                                {{ errors.required[0] }}
                            </p>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" class="mt-3 text-left mb-0" v-if="form.model !== 'Company'">
                            <label class="state">{{ $t('docTypes.tagsLabel') }}</label>
                            <v-select multiple :options="allTags" class="f-12" :reduce="(option) => option.id"
                                v-model="form.tags"
                                :disabled="!allowAddDocType && (!editDocType || (editDocType && !allowUpdateDocType))" />
                            <p v-if="errors && errors.tags" class="field-error mb-lg-3">
                                {{ errors.tags[0] }}
                            </p>
                    </b-col>
                    <b-col cols="12" class="mt-3">
                        <b-form-group :label="$t('docTypes.notifyAdminLabel')" class="text-left mb-0">
                            <b-form-select
                                :disabled="!allowAddDocType && (!editDocType || (editDocType && !allowUpdateDocType))"
                                v-model="form.notify_admin" :options="yesNoOptions" class="unit f-12" />
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" class="mt-3" v-if="form.model !== 'Company'">
                        <b-form-group :label="$t('docTypes.notifyDriverLabel')" class="text-left mb-0">
                            <b-form-select
                                :disabled="!allowAddDocType && (!editDocType || (editDocType && !allowUpdateDocType))"
                                v-model="form.notify_driver" :options="yesNoOptions" class="unit f-12" />
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" class="mt-3">
                        <b-form-group :label="$t('docTypes.autoArchiveExpiryLabel')" class="text-left mb-0">
                            <b-form-select
                                :disabled="!allowAddDocType && (!editDocType || (editDocType && !allowUpdateDocType))"
                                v-model="form.auto_archive" :options="yesNoOptions" class="unit f-12" />
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" class="mt-3">
                        <b-form-group :label="$t('docTypes.autoArchiveUpdateLabel')" class="text-left mb-0">
                            <b-form-select
                                :disabled="!allowAddDocType && (!editDocType || (editDocType && !allowUpdateDocType))"
                                v-model="form.auto_archive_on_update" :options="yesNoOptions" class="unit f-12" />
                        </b-form-group>
                    </b-col>
                </b-row>
            </div>
            <template #modal-footer>
                <div class="text-right modal-footer border-0 p-0 mb-0 mt-0">
                    <b-button class="mx-0 h-40px w-100px m-0"
                        :class="(allowAddDocType && !editDocType) || (editDocType && allowUpdateDocType) ? 'mr-3' : ''"
                        @click="resetForm()" variant="secondary">{{ $t('docTypes.cancel') }}</b-button>
                    <div class="d-flex align-items m-0"
                        v-if="(allowAddDocType && !editDocType) || (editDocType && allowUpdateDocType)">
                        <b-button class="mx-0 mb-0 h-40px w-100px m-0" variant="primary"
                            @click="updateDocType()">{{ $t('docTypes.save') }}</b-button>
                    </div>
                </div>
            </template>
        </b-modal>
        <DeleteModal v-if="showDeletePopup" @confirm="deleteItem($event)" />
    </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import DeleteModal from "@/components/DeleteModal.vue";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
export default {
    name: "DocTypes",
    components: {
        vSelect,
        DeleteModal
    },
    data() {
        return {
            items: [],
            perPage: 50,
            currentPage: 1,
            editDocType: false,
            docTypeID: null,
            emptyTable: false,
            allTags: [],
            showDeletePopup: false,
            docTypeData: null,
            form: {
                type: "",
                model: "",
                required: false,
                tags: [],
                auto_archive: false,
                auto_archive_on_update: false,
                notify_driver: false,
                notify_admin: true
            },
            errors: {},
            pageOptions: [
                {
                    value: 10,
                    text: "10",
                },
                {
                    value: 25,
                    text: "25",
                },
                {
                    value: 50,
                    text: "50",
                },
                {
                    value: 100,
                    text: "100",
                },
            ],
        }
    },
    computed: {
        ...mapGetters(["userCompany", 'rolePermissions', 'tags']),
        translatedFields() {
            return [
                { key: "type", label: this.$t('docTypes.typeColumn'), sortable: true, thClass: 'font-table-weight-bold', stickyColumn: true },
                { key: "model", label: this.$t('docTypes.modelColumn'), sortable: true, thClass: 'font-table-weight-bold' },
                { key: "required", label: this.$t('docTypes.requiredColumn'), sortable: true, thClass: 'font-table-weight-bold' },
                { key: "tags", label: this.$t('docTypes.tagsColumn'), sortable: true, thClass: 'font-table-weight-bold' },
                { key: "notify_admin", label: this.$t('docTypes.notifyAdminColumn'), sortable: true, thClass: 'font-table-weight-bold' },
                { key: "notify_driver", label: this.$t('docTypes.notifyDriverColumn'), sortable: true, thClass: 'font-table-weight-bold' },
                { key: "auto_archive", label: this.$t('docTypes.autoArchiveExpiryColumn'), sortable: true, thClass: 'font-table-weight-bold' },
                { key: "auto_archive_on_update", label: this.$t('docTypes.autoArchiveUpdateColumn'), sortable: true, thClass: 'font-table-weight-bold' },
                { key: "Action", sortable: true, thClass: 'font-table-weight-bold' },
            ];
        },
        modelSelectOptions() {
            return [
                { value: '', text: '' },
                { value: 'Driver', text: this.$t('docTypes.modelDriver') },
                { value: 'Vehicle', text: this.$t('docTypes.modelVehicle') },
                { value: 'Trailer', text: this.$t('docTypes.modelTrailer') },
                { value: 'Company', text: this.$t('docTypes.modelCompany') },
            ];
        },
        yesNoOptions() {
            return [
                { value: '', text: '' },
                { value: true, text: this.$t('docTypes.yes') },
                { value: false, text: this.$t('docTypes.no') },
            ];
        },
        allowViewDocType() {
            return this.rolePermissions && this.rolePermissions['Doc Types'] && this.rolePermissions['Doc Types'][0].allow
        },
        allowAddDocType() {
            return this.rolePermissions && this.rolePermissions['Doc Types'] && this.rolePermissions['Doc Types'][2].allow
        },
        allowUpdateDocType() {
            return this.rolePermissions && this.rolePermissions['Doc Types'] && this.rolePermissions['Doc Types'][1].allow
        },
        allowDeleteDocType() {
            return this.rolePermissions && this.rolePermissions['Doc Types'] && this.rolePermissions['Doc Types'][3].allow
        },
        rows() {
            return this.items.length;
        },
        positionText() {
            const endIndex = this.currentPage * this.perPage;
            const startIndex = this.rows > 0 ? (this.currentPage - 1) * this.perPage + 1 : 0;
            const end = endIndex > this.rows ? this.rows : endIndex;
            return this.$t('docTypes.positionText', { start: startIndex, end, total: this.rows });
        }
    },
    methods: {
        ...mapActions(["getAllDocTypes", "setLoader", "setNotification", "addDocTypeItem", "updateDocTypeItem", "getAllTags", "deleteDocTypeItem"]),
        async deleteItem(status) {
            if (status) {
                try {
                    await this.deleteDocTypeItem(`${this.docTypeID}/?company_id=${this.userCompany}`)
                    await this.setNotification({
                        msg: this.$t('docTypes.docTypeDeleted'),
                        type: "success",
                        color: "green",
                    });
                    this.docTypeID = null
                    this.showDeletePopup = false;
                    await this.getAllDocTypesData()
                }
                catch (error) {
                    this.docTypeID = null
                    this.showDeletePopup = false;
                    if (typeof error === "object" && error.error) {
                        await this.setNotification({
                            msg: error.error,
                            type: "error",
                            color: "red",
                        });
                    }
                }
            }
            else this.showDeletePopup = false
        },
        showDocTypeDeletePopup(id) {
            this.showDeletePopup = true;
            this.docTypeID = id;
        },
        getModelValue(event) {
            if (event === 'Company') {
                this.form.required = false;
                this.form.tags = [];
                this.form.notify_driver = false;
            }
        },
        async updateDocType() {
            try {
                this.errors = {}
                const nullKeys = this.checkNullValues({
                    type: this.form.type,
                    model: this.form.model,
                    required: this.form.required
                });
                if (nullKeys.length === 0) {
                    let successMsg = this.$t('docTypes.docTypeAdded')
                    if (this.editDocType) {
                        successMsg = this.$t('docTypes.docTypeUpdated')
                        try {
                            this.setLoader(true)
                            await this.updateDocTypeItem({
                                id: this.docTypeID,
                                payload: { ...this.form, company: this.userCompany }
                            })
                        }
                        catch (e) {
                            this.setLoader(false)
                            await this.setNotification({
                                msg: e,
                                type: "error",
                                color: "red",
                            });
                            return
                        }
                    }
                    else {
                        try {
                            this.setLoader(true)
                            await this.addDocTypeItem({ ...this.form, company: this.userCompany })
                        }
                        catch (e) {
                            this.setLoader(false)
                            await this.setNotification({
                                msg: e,
                                type: "error",
                                color: "red",
                            });
                            return
                        }
                    }
                    await this.setNotification({
                        msg: successMsg,
                        type: "success",
                        color: "green",
                    });
                    this.setLoader(false)
                    this.resetForm()
                    this.getAllDocTypesData()
                }
                else {
                    let error = {};
                    nullKeys.forEach((x) => {
                        error[x] = [this.$t('docTypes.fieldRequired')];
                    });
                    throw error;
                }
            }
            catch (error) {
                if (typeof error === "object") {
                    this.errors = error;
                    // eslint-disable-next-line no-ex-assign
                }
            }
        },
        checkNullValues(payload) {
            let nullKeys = [];
            for (let [key, value] of Object.entries(payload)) {
                if (value === "") {
                    nullKeys.push(key);
                }
            }
            return nullKeys;
        },
        resetForm() {
            this.errors = {}
            this.$bvModal.hide('add-type-modal')
            this.docTypeData = null
            this.docTypeID = null
            this.editDocType = false
            this.form = {
                type: "",
                model: "",
                required: false,
                tags: [],
                auto_archive: false,
                auto_archive_on_update: false,
                notify_driver: false,
                notify_admin: true
            }

        },
        editDocTypeItem(data) {
            this.editDocType = true
            this.form = {
                type: data.type,
                model: data.model,
                required: data.required,
                auto_archive: data.auto_archive,
                auto_archive_on_update: data.auto_archive_on_update,
                tags: data.tags.length ? data.tags.map((tag) => tag.id) : [],
                notify_driver: data.notify_driver,
                notify_admin: data.notify_admin
            }
            this.docTypeID = data.id
            this.$bvModal.show('add-type-modal')
        },
        async getAllDocTypesData() {
            try {
                this.items = []
                const data = await this.getAllDocTypes()
                data.map((item) => {
                    this.items.push({
                        id: item.id,
                        type: item.type,
                        model: item.model,
                        required: item.required,
                        auto_archive: item.auto_archive,
                        auto_archive_on_update: item.auto_archive_on_update,
                        notify_driver: item.notify_driver,
                        tags: item.tags_obj,
                        notify_admin: item.notify_admin
                    })
                })
            }
            catch (e) {
                console.log(e)
            }
        }
    },
    async mounted() {
        this.getAllDocTypesData()
        this.tags.map((item) => {
            this.allTags.push({
                id: item.id,
                label: item.add_tag,
            });
        });
    }
}
</script>